module.exports = __webpack_public_path__ + "img/web_world_map.ee3ab537.jpg";